var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    {
      staticClass: "radio",
      class: {
        "radio--inline": _vm.inline
      }
    },
    [
      _vm.legend
        ? _c("legend", [
            _c("span", {
              directives: [
                {
                  name: "sanitize",
                  rawName: "v-sanitize",
                  value: _vm.legend,
                  expression: "legend"
                }
              ]
            }),
            _vm._v(" "),
            _vm.legendOption
              ? _c("span", {
                  directives: [
                    {
                      name: "sanitize",
                      rawName: "v-sanitize",
                      value: _vm.legendOption,
                      expression: "legendOption"
                    }
                  ],
                  staticClass: "optional"
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function(option, index) {
        return _c(
          "div",
          {
            key: option.value,
            staticClass: "radio-area",
            class: {
              "radio-area--block": _vm.vertical
            }
          },
          [
            _c("input", {
              attrs: {
                type: "radio",
                id: _vm.uniqueId + "-" + index + "-" + option.value,
                name: _vm.name,
                required: _vm.required,
                disabled: _vm.disabled
              },
              domProps: {
                value: option.value,
                checked: option.value === _vm.value
              },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c("label", {
              attrs: { for: _vm.uniqueId + "-" + index + "-" + option.value },
              domProps: { innerHTML: _vm._s(option.label) }
            })
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }